import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { timeOffService } from '../api/time-off.service';
import type { CreateTimeOffTypePayload } from '../types';

export function useCreateTimeOffType() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { t } = useTranslation('timeOff');
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: CreateTimeOffTypePayload) => timeOffService.createType(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['time-off', 'types', orgId] });
      toast.success({ title: t('settings.toasts.typeCreated') });
    },
  });
}
